const MB_30 = 31457280;

export {
    MB_30
}